import { useLanguage } from "../../context/LanguageContext";
import { CONTACT } from "../../i18n";
import { scrollToId } from "./Navbar";

export const Footer = () => {
  const { t } = useLanguage();
  return (
    <footer data-testid="footer" className="relative overflow-hidden border-t border-white/10 pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16">
          <div>
            <img src="/logo-white.png" alt="LAJA Air Tech Services" className="h-16 w-auto mb-6" />
            <p className="text-slate-400 text-sm max-w-sm leading-relaxed">{t.footer.tagline}</p>
          </div>
          <nav className="flex flex-wrap gap-x-8 gap-y-3">
            {["about", "services", "fleet", "sales", "quote", "contact"].map((id) => (
              <button
                key={id}
                data-testid={`footer-link-${id}`}
                onClick={() => scrollToId(id)}
                className="text-sm text-slate-400 hover:text-white transition-colors"
              >
                {t.nav[id === "sales" ? "sales" : id]}
              </button>
            ))}
          </nav>
        </div>

        <div className="select-none pointer-events-none text-center leading-none font-display font-black text-[13.5vw] tracking-tighter text-outline" aria-hidden="true">
          LAJA AIR TECH
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-mono-tech text-xs text-slate-500">
            © {new Date().getFullYear()} LAJA AIR TECH SERVICES LLC. {t.footer.rights}
          </p>
          <p className="font-mono-tech text-xs text-slate-500">
            {CONTACT.address} · {CONTACT.phone}
          </p>
        </div>
      </div>
    </footer>
  );
};
